import { render, staticRenderFns } from "./operationDepartment.vue?vue&type=template&id=ecd38084&scoped=true"
import script from "./operationDepartment.vue?vue&type=script&lang=js"
export * from "./operationDepartment.vue?vue&type=script&lang=js"
import style0 from "./operationDepartment.vue?vue&type=style&index=0&id=ecd38084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd38084",
  null
  
)

export default component.exports